export default "__VITE_ASSET__BMEmoW2___"